import { render } from "./ReviewDetailViewer.vue?vue&type=template&id=cff819c0&ts=true"
import script from "./ReviewDetailViewer.vue?vue&type=script&lang=ts"
export * from "./ReviewDetailViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__